export const tableHeadings = [
  "Field",
  "From",
  "To",
  "Changed by",
  "Changed at (UTC)",
];
